module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.2af342578388cb3be264efe3382f5074.woff";